/* eslint-disable @next/next/no-img-element */
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import H2 from '@base/H2/H2';
import H4 from '@base/H4/H4';
import { getImage } from '@utils/imageHelper';
import H3 from '@base/H3/H3';
import H6 from '@base/H6/H6';

const Wrapper = styled.div`
  max-width: 720px;
  margin: 120px auto 160px auto;
`;

const Header = styled.div`
  text-align: center;
  max-width: 540px;
  margin: auto;
  margin-bottom: 56px;
  h2 {
    margin-top: 16px;
    margin-bottom: 12px;
  }
  h4 {
    color: var(--color-text-secondary);
    font-weight: normal;
  }
`;

const StepBlock = styled.div`
  max-width: 340px;
  text-align: center;
  padding: 16px;
  img {
    margin-bottom: 16px;
  }
  h6 {
    font-weight: normal;
    color: var(--color-text-secondary);
    margin-top: 12px;
  }
`;

const StepWrapper = styled.div`
  display: flex;
  flex-direction: ${({ isRight }) => (isRight ? 'row-reverse' : 'row')};
  margin: auto -32px;
`;

const connectors = [
  getImage('combat/Dotted line - 6.svg'),
  getImage('combat/Dotted line - 7.svg'),
  getImage('combat/Dotted line - 8.svg')
];

const Steps = ({ goalUID }) => {
  const { stepsMeta, steps } = useSelector(
    ({ combats }) => combats.staticData[goalUID] || {}
  );
  return (
    <Wrapper>
      <Header>
        <img src={stepsMeta.logo} alt="steps-logo" />
        <H2>{stepsMeta.title}</H2>
        <H4>{stepsMeta.subtitle}</H4>
      </Header>
      {steps.map((step, index) => {
        return (
          <StepWrapper key={`step-${step.id}`} isRight={index % 2 === 1}>
            <StepBlock>
              <img src={step.image} alt={`step-${index}`} />
              <H3>{step.title}</H3>
              <H6>{step.subtitle}</H6>
            </StepBlock>
            {index !== 2 && (
              <img
                src={connectors[index === 3 ? 2 : index]}
                alt={`connector-${index}`}
              />
            )}
          </StepWrapper>
        );
      })}
    </Wrapper>
  );
};

export default Steps;

Steps.propTypes = {
  goalUID: PropTypes.string.isRequired
};
